import { useQuery } from '@apollo/client/react';
import { CustomerReport, Recipient } from 'domain/shared/newProject';
import { GET_PROJECT_REPORTS_AND_RECIPIENTS } from 'domain/projects/newProject/customerReport/graphql/reportsQueries';
import { NetworkStatus } from '@apollo/client';

interface CustomerReportsData {
  customerReports: CustomerReport[];
  reportRecipients: Recipient[];
}

export const useCustomerReports = (projectId: StringOrNumber) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{
    baseProject: CustomerReportsData;
  }>(GET_PROJECT_REPORTS_AND_RECIPIENTS, {
    variables: { id: projectId.toString() },
    skip: !projectId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    data: data?.baseProject,
    loading,
    error,
    refetch,
    isDataReloading: !data || networkStatus !== NetworkStatus.ready,
  };
};
